<template>
  <ConfirmModal
      color="error"
      icon="mdi-check"
      :maxWidth="500"
      itemKey="TicketItemTask"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :confirmData="updateStatusUndoneData"
      @onConfirm="(response) => $emit('onUpdateStatusUndone', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketItemTasksAuth from '@/services/ticket-item-tasks-auth'

  import ConfirmModal from '@/components/_Part/_Modal/Confirm'

  export default {
    name: 'UpdateStatusUndone',
    props: [
      'id'
    ],
    emits: [
      'onUpdateStatusUndone'
    ],
    components: {
      ConfirmModal
    },
    methods: {
      fetchData() {
        return TicketItemTasksAuth
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Označiť úlohu z ' + this.$moment(Item.createdAt).format('DD.MM.YYYY HH:mm') + ' od ' + Item.Creator.name + ' ako nedokončenú'
      },
      setQuestion(Item) {
        return 'Naozaj chcete označiť úlohu z ' + this.$moment(Item.createdAt).format('DD.MM.YYYY HH:mm') + ' od ' + Item.Creator.name + ' ako nedokončenú?'
      },
      updateStatusUndoneData() {
        return TicketItemTasksAuth
          .updateStatusUndone({
            id: this.id
          })
      }
    }
  }
</script>
